import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import PointsTransactionsList from './points-transactions-list';
import PointsTransactionsSearch from './points-transactions-search';
import {getPointsTransactions} from '../../../../actions/points';
import PageTitle from '../../../common/page-title/index';

import './styles.css';

class PointsTransactions extends Component {
  handleInputChange = (e) => {
    this.setState({customerNumber: e.target.value});
  };
  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };
  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };
  handlePointsPotChange = (e) => {
    this.setState({pointsPot: e});
  };
  handleSearch = () => {
    const {
      customerNumber, dateFrom, dateTo, pointsPot
    } = this.state;
    this.props.dispatch(getPointsTransactions(customerNumber, dateFrom, dateTo, pointsPot))
      .then(() => {
        this.setState({
          pageNumber: 1
        });
      });
  };
  handleClear = () => {
    this.setState({
      customerNumber: '',
      dateFrom: '',
      dateTo: '',
      pointsPot: [],
      pageNumber: 1
    }, this.handleSearch);
  };
  handlePageChange = (page) => {
    this.setState({pageNumber: page}, this.afterPageChange);
  };
  afterPageChange = () => {
    const {
      customerNumber, dateFrom, dateTo, pointsPot, pageNumber
    } = this.state;
    this.props.dispatch(getPointsTransactions(customerNumber, dateFrom, dateTo, pointsPot, pageNumber));
  };

  constructor(props) {
    super(props);
    this.state = {
      customerNumber: '',
      dateFrom: '',
      dateTo: '',
      pointsPot: [],
      pageNumber: 1
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getPointsTransactions());
  }

  render() {
    let table = <div/>;
    let search = (
      <div>
        Loading..
      </div>
    );
    if (this.props.fetched) {
      table = (
        <PointsTransactionsList
          currentPage={this.state.pageNumber}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          onPageChange={this.handlePageChange}
          paging={this.props.paging}
          points_transactions={this.props.points_transactions}
        />
      );

      search = (
        <PointsTransactionsSearch
          dateFromValue={this.state.dateFrom}
          dateToValue={this.state.dateTo}
          onClear={this.handleClear}
          onDateFromChange={this.handleDateFromChange}
          onDateToChange={this.handleDateToChange}
          onInputChange={this.handleInputChange}
          onPointsPotChange={this.handlePointsPotChange}
          onSearch={this.handleSearch}
          pointsPotList={this.props.pointsPotList}
          pointsPotValue={this.state.pointsPot}
          searchValue={this.state.orderNumber}
        />
      );
    }
    return (
      <Container fluid className="orders">
        <PageTitle>
          Points Transactions
        </PageTitle>
        <Row>
          <Col md={12}>
            {search}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {table}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.points.fetching,
  fetched: state.points.fetched,
  pointsPotList: state.points.meta['point-pots'],
  points_transactions: state.points.transactions.list,
  paging: state.points.transactions.paging,
  links: state.points.transactions.links
});

export default connect(mapStateToProps)(PointsTransactions);
